import React, { useEffect, useState } from 'react';
import './Filters.css';
import { filterPresets } from '../Functions';
import ActiveFilters from './ActiveFilters';

// Chevron down SVG
const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const Filters = ({ data, filterOptions, setCurrrentPosts, currentPosts }) => {
  const [openFilter, setOpenFilter] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [filtersVisible, setFiltersVisible] = useState(true);

  const [priceToggle, setPriceToggle] = useState(0);
  const [customizeToggle, setCustomizeToggle] = useState(false);
  const [count, setCount] = useState(0);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

  const [currentFilters, setCurrentFilters] = useState()
  const toggleFilter = (filterName) => {
    setOpenFilter(openFilter === filterName ? null : filterName);
  };
  useEffect(() => {
    if (currentFilters && Object.keys(currentFilters).length > 0) {
      const filteredPosts = filterPresets(data, currentFilters, priceToggle, customizeToggle);
      setCurrrentPosts(filteredPosts);
      console.log("filters, working", currentFilters, filteredPosts, data);
    } else {
      setCurrrentPosts(data);
    }
  }, [currentFilters])

  useEffect(() => {
    if (data) {
      const filteredPosts = filterPresets(data, currentFilters, priceToggle, customizeToggle);
      setCurrrentPosts(filteredPosts);
    }
  }, [priceToggle, customizeToggle]);

  useEffect(() => {
    if (currentPosts) {
      let count = 0;
      Object.keys(currentPosts).forEach((key) => {
        count += currentPosts[key].length;
      });
      setCount(count);
    }
  }, [currentPosts])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`filters_container ${mobileOpen ? 'filters_open' : ''}`}>

      <div className="filters_overlay" onClick={() => setMobileOpen(false)} />

      <div className="filters_panelHeader">
        <span className='txt-font'>Filters — {count > 1 ? `${count} Results` : `${count} Result`}</span>

        {/* Show/Hide toggle for desktop */}
        <button
          className={`filters_toggleBtn ${filtersVisible ? 'filters_toggleBtn--open' : ''}`}
          onClick={() => setFiltersVisible(!filtersVisible)}
        >
          {filtersVisible ? 'Hide Filters' : 'Show Filters'}
          <ChevronDown />
        </button>

        <button className="filters_closeBtn" onClick={() => setMobileOpen(false)}>
          &times;
        </button>

        <button className="filters_mobileToggle" onClick={() => setMobileOpen(true)}>
          Filters
        </button>
      </div>

      <div className={`filters_panel ${!filtersVisible && !isMobile ? 'filters_panel--hidden' : ''}`} onClick={() => setMobileOpen(false)}>
        {filterOptions && Object.entries(filterOptions).map(([key, options]) => (
          <div className={`filters_section ${openFilter === key ? 'open_f_title' : ''}`} key={key}>

            <div className={`filters_title`} onClick={() => { toggleFilter(key); console.log("toggleFilter ", key); }}>
              {key} <span className="filters_arrow">{openFilter === key ? '\u25B2' : '\u25BC'}</span>
            </div>

            {((openFilter === key && openFilter !== 'Color' && !isMobile) || (isMobile && key !== 'Color')) && (
              <div className="filters_dropdown">
                {options.attrs.map((opt) => (
                  <label key={opt} className="filters_checkbox">
                    <input type="checkbox" value={opt}
                      checked={currentFilters && currentFilters[key] && currentFilters[key].includes(opt)}
                      onChange={(e) => {
                        const newFilters = { ...currentFilters };
                        if (!newFilters[key]) {
                          newFilters[key] = [];
                        }
                        if (e.target.checked) {
                          newFilters[key].push(opt);
                        } else {
                          newFilters[key] = newFilters[key].filter(item => item !== opt);
                          if (newFilters[key].length === 0) {
                            delete newFilters[key];
                          }
                        }
                        console.log("newFilters", newFilters);
                        setCurrentFilters(newFilters);
                      }}
                    /> {opt}
                  </label>
                ))}
              </div>
            )}

            {((openFilter === key && openFilter === 'Color' && !isMobile) || (isMobile && key === 'Color')) && (
              <div className="filters_dropdown filters_colors">
                {options.attrs.map((color, i) => (
                  <div
                    key={i}
                    className={`filters_colorDot ${currentFilters && currentFilters[key] && currentFilters[key].includes(color) ? 'filters_colorDot_active' : ''}`}

                    onClick={() => {
                      const newFilters = { ...currentFilters };
                      if (!newFilters[key]) {
                        newFilters[key] = [];
                      }
                      if (newFilters[key].includes(color)) {
                        newFilters[key] = newFilters[key].filter(item => item !== color);
                        if (newFilters[key].length === 0) {
                          delete newFilters[key];
                        }
                      } else {
                        newFilters[key].push(color);
                      }
                      console.log("newFilters", newFilters);
                      setCurrentFilters(newFilters);
                    }}
                  >
                    <div className="both_center"
                      style={{ backgroundColor: color }} >
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <div className={`filters_section mobile_customizable ${priceToggle ? 'bg_orange' : ''}`}>
          <div className="filters_title"
            onClick={() => { setPriceToggle(!priceToggle); }}

          > Price : {priceToggle ? 'Low to High' : 'High to Low'}</div>
        </div>

        <div className={`filters_section ${customizeToggle ? 'bg_orange' : ''} mobile_customizable`}>
          <div className={`filters_title`}
            onClick={() => { setCustomizeToggle(!customizeToggle); }}

          > + Customizable</div>
        </div>
      </div>

      <ActiveFilters
        currentFilters={currentFilters}
        setCurrentFilters={setCurrentFilters}
        customizeToggle={customizeToggle}
        setCustomizeToggle={setCustomizeToggle}
      />
    </div>
  );
};

export default Filters;
